'use client';
import { useEffect } from 'react';
import { UTMUtil } from '@/utils/utm.util';

/**
 * UTM Tracker Component
 * Automatically captures UTM parameters when the page loads
 */
const UTMTracker: React.FC = () => {
  useEffect(() => {
    // Capture UTM parameters on page load
    UTMUtil.captureUTMParams();
  }, []);

  // This component doesn't render anything visible
  return null;
};

export default UTMTracker;
